import * as ActionsUser from "./Action";

export default {
  ...ActionsUser,
};
